import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getDemandInFormatSelect } from '../api/demandInFormatApi';

type QueryFnType = typeof getDemandInFormatSelect;

type UseDemandInFormatSelectOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useDemandInFormatSelect = ({ config = {} }: UseDemandInFormatSelectOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['demandInFormatSelect', i18n.language],
        queryFn: () => getDemandInFormatSelect(),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};
